import { makeObservable, observable, action } from 'mobx';
import { InputGroupChangeTracker } from '.';

export default class ContractChangeTracker {
    inputGroupChangeTrackers: Map<string, InputGroupChangeTracker> = new Map();

    constructor() {
        makeObservable(this, {
            inputGroupChangeTrackers: observable,
            createInputGroupChangeTracker: action,
            clearInputGroupChangeTrackers: action
        });
    }

    createInputGroupChangeTracker(inputGroupId: string, inputGroupName: string): InputGroupChangeTracker {
        const inputGroupChangeTracker = new InputGroupChangeTracker(inputGroupName);
        this.inputGroupChangeTrackers.set(inputGroupId, inputGroupChangeTracker);
        return inputGroupChangeTracker;
    }

    getInputGroupChangeTracker(inputGroupId: string): InputGroupChangeTracker | undefined {
        return this.inputGroupChangeTrackers.get(inputGroupId);
    }

    clearInputGroupChangeTrackers() {
        this.inputGroupChangeTrackers.forEach(inputGroupChangeTracker =>
            inputGroupChangeTracker.clearInputChangeTrackers()
        );

        this.inputGroupChangeTrackers.clear();
    }
}
